import { TabActions, TabActionTypes, TabProps } from "./types";

export const setTabData = (tab: TabProps): TabActions => ({
  type: TabActionTypes.SET_TAB,
  payload: tab,
});
